import { createLinkEntry } from "../../../links/discoverGameLinks";
import { DiscoverClubTeamFormField, DiscoverClubTeamSide } from "../constants";
import type { ProgramGameFormState, ProgramGameSelectOption } from "./types";

export const ProgramGameClubTeamSide = DiscoverClubTeamSide;

export type ProgramGameClubTeamSide = DiscoverClubTeamSide;

export const PROGRAM_GAME_CLUB_TEAM_SIDE_ERRORS: Record<
	ProgramGameClubTeamSide,
	{
		club: DiscoverClubTeamFormField.HomeClub | DiscoverClubTeamFormField.AwayClub;
		team: DiscoverClubTeamFormField.HomeTeam | DiscoverClubTeamFormField.AwayTeam;
	}
> = {
	[ProgramGameClubTeamSide.Home]: {
		club: DiscoverClubTeamFormField.HomeClub,
		team: DiscoverClubTeamFormField.HomeTeam,
	},
	[ProgramGameClubTeamSide.Away]: {
		club: DiscoverClubTeamFormField.AwayClub,
		team: DiscoverClubTeamFormField.AwayTeam,
	},
};

export const CLUB_LOAD_DEBOUNCE_MS = 300;

/** Matches `Eyeball\Enum\GameType::CHAMPIONSHIP` — default type when programming a discover game. */
export const PROGRAM_GAME_DEFAULT_GAME_TYPE = "championnat";

export const DEFAULT_SELECTED_OWNERSHIP = "eyeball";

export const KICK_OFF_HOUR_OPTIONS: ProgramGameSelectOption[] = Array.from({ length: 24 }, (_, i) => {
	const value = String(i).padStart(2, "0");
	return { value, label: value };
});

export const KICK_OFF_MINUTE_OPTIONS: ProgramGameSelectOption[] = Array.from({ length: 60 }, (_, i) => {
	const value = String(i).padStart(2, "0");
	return { value, label: value };
});

export function emptyProgramGameForm(): ProgramGameFormState {
	return {
		homeClub: null,
		homeTeam: null,
		awayClub: null,
		awayTeam: null,
		gameType: null,
		gameDate: "",
		kickOffHour: null,
		kickOffMinute: null,
		isNational: null,
		nationalLeague: null,
		gender: null,
		ownershipSelections: [],
		teamsheetLinks: [createLinkEntry()],
		videoLinks: [createLinkEntry()],
		priority: { value: "5", label: "5" },
	};
}
